import { useLabelVersion } from '../../../../../../features/labels/LabelsProvider';
import { labelCentro } from '../../../../../../features/labels/labels';
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import LogoutIcon from "@mui/icons-material/Logout";
import AppsIcon from "@mui/icons-material/Apps";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import EmailIcon from "@mui/icons-material/Email";
import { LogoutUsuario } from "../../../../../../utils/ApiLogin";

import LogoNanoox from "../../../../assets/img/APP-nanoox-Bolt-Sin-Fondo.png";
import "./DrawerNanooxBolt.css";

function formatName(str) {
  if (!str) return "";
  const parts = str.match(/[a-zA-Z0-9]+/g) || [str];
  return parts
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
}

export default function DrawerNanooxBolt({
  barcos,
  open,
  toggleDrawer,
  version,
  translate,
  selectedCentro,
  setSelectedCentro,
  servidor,
}) {
  useLabelVersion();
  const t = typeof translate === "function" ? translate : (key) => key;

  const handleSelectCentro = (barco) => {
    setSelectedCentro(barco);
    localStorage.setItem("CENTRO", barco);
  };

  const handleLogout = async () => {
    await LogoutUsuario(servidor);
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <aside
      className={`drawer ${open ? "open" : ""}`}
      onMouseEnter={toggleDrawer(true)}
      onMouseLeave={toggleDrawer(false)}
    >
      <div className="drawer-content">
        <div className="drawer-section">
          <img
            src={LogoNanoox}
            alt="Nanoox"
            className="logo-nanoox"
            role="button"
            style={{ width: "6vw" }}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            className="drawer-btn special"
            onClick={() => {
              window.location = "/home";
            }}
          >
            <AppsIcon style={{ fontSize: "1vw" }} /> {t("inicio")}
          </button>
          <button
            className="drawer-btn special"
            onClick={handleLogout}
          >
            <LogoutIcon style={{ fontSize: "1vw" }} /> {t("cerrar_sesion")}
          </button>
        </div>

        <h2 className="drawer-title">{t("barcos")}</h2>
        <div className="drawer-section">
          {Array.isArray(barcos) && barcos.length > 0 ? (
            barcos.map((barco) => (
              <button
                key={barco}
                className={`drawer-btn ${selectedCentro === barco ? "active" : ""}`}
                onClick={() => handleSelectCentro(barco)}
              >
                <DirectionsBoatIcon style={{ fontSize: "1vw" }} />
                {labelCentro({ region: "flux", area: "barcos", centro: barco }, formatName(barco))}
              </button>
            ))
          ) : (
            <p style={{ color: "#999", textAlign: "center" }}>
              {t("no_boats_available")}
            </p>
          )}
        </div>
      </div>

      <footer className="drawer-footer">
        <p>
          <EmailIcon style={{ fontSize: "1vw", color: "#c3c3c3" }} />{" "}
          informaciones@itgchile.com
        </p>
        <p>
          <SmartphoneIcon style={{ fontSize: "1vw", color: "#c3c3c3" }} /> +56 (65)
          22 52 881
        </p>
        <p>
          <SmartphoneIcon style={{ fontSize: "1vw", color: "#c3c3c3" }} /> +56 (65)
          22 50 080
        </p>
        <p>© ITG Chile v{version}</p>
      </footer>
    </aside>
  );
}
